import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { gateway } from 'libs/generated-grpc-web';

@Component({
  selector: 'mg-event-invite-notification',
  templateUrl: './MgEventInviteNotification.element.html',
  styleUrls: ['./MgEventInviteNotification.element.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MgEventInviteNotificationElement {
  @Input()
  notification?: gateway.notification_pb.Notification.AsObject;
}
